import { useState } from "react";

/**
 * Per-device note-editor preferences: toolbar visibility. Stored in
 * localStorage so the choice survives reloads (same best-effort pattern as the
 * day-note draft mirror — never let a blocked localStorage take the editor
 * down).
 */

const TOOLBAR_KEY = "otdesk.note.toolbar";

function read(key: string, fallback: string): string {
  try {
    return localStorage.getItem(key) ?? fallback;
  } catch {
    return fallback;
  }
}

function write(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // best-effort preference persistence only
  }
}

export function useNotePrefs() {
  const [toolbarOpen, setToolbarOpenState] = useState<boolean>(() => read(TOOLBAR_KEY, "1") === "1");

  const setToolbarOpen = (open: boolean) => {
    setToolbarOpenState(open);
    write(TOOLBAR_KEY, open ? "1" : "0");
  };

  // Show the toolbar without persisting the preference (e.g. Ctrl/Cmd+K opens
  // the link popover even when the user keeps the toolbar hidden by default).
  const showToolbarTransient = () => setToolbarOpenState(true);

  return { toolbarOpen, setToolbarOpen, showToolbarTransient };
}
